<template>
  <v-card class="d-flex pa-4 flex-column" outlined style="min-height: 500px">
    <v-dialog v-model="modal" width="500">
      <image-modal
        ref="ytmodal"
        @onConfirm="addCommand"
        :modal="modal"
        v-on:update:modal="modal = $event"
      />
    </v-dialog>
    <v-card class="d-flex pa-8 flex-column" v-if="loadingView">
      <v-skeleton-loader
        class="d-flex justify-center align-center pa-4 mb-4"
        type="heading"
        elevation="0"
      />
      <div>
        <v-row style="align-items: center" v-for="i in 3" :key="i">
          <v-col cols="4" sm="2">
            <v-skeleton-loader type="text" elevation="0" />
          </v-col>
          <v-col cols="2" sm="1">
            <v-skeleton-loader type="text" max-width="10" elevation="0" />
          </v-col>
          <v-col cols="12" sm="9" v-if="i != 3">
            <v-skeleton-loader type="text" elevation="0" />
          </v-col>
          <v-col cols="12" sm="9" v-else>
            <v-skeleton-loader type="article" elevation="1" />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="4" sm="2">
            <v-skeleton-loader type="text" elevation="0" />
          </v-col>
          <v-col cols="2" sm="1">
            <v-skeleton-loader type="text" max-width="10" elevation="0" />
          </v-col>
          <v-col cols="12" sm="5">
            <v-skeleton-loader type="text" elevation="0" />
          </v-col>
          <v-col cols="12" sm="4">
            <v-skeleton-loader type="text" elevation="0" />
          </v-col>
        </v-row>
      </div>
      <div class="ma-2 d-flex justify-end">
        <v-skeleton-loader class="ma-1" type="button" elevation="0" />
        <v-skeleton-loader class="ma-1" type="button" elevation="0" />
      </div>
    </v-card>
    <v-card class="d-flex pa-8 flex-column" v-else>
      <div class="d-flex justify-center align-center pa-4 mb-4">
        <h3>Broadcast Information</h3>
      </div>
      <div>
        <v-row style="align-items: center">
          <v-col cols="4" sm="2"> To </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col
            cols="12"
            sm="9"
            :style="`color:${isView ? 'rgba(0, 0, 0, 0.38)' : 'black'}`"
          >
            {{ sendTo }}
            <v-chip
              class="ma-2"
              v-if="selected.length > 4 && !toAll"
              @click="seeMoreEmail"
              >+{{ selected.length - 4 }} more</v-chip
            >
            <v-btn
              to="/broadcast/broadcast"
              v-if="dataEdit != null && isEdit"
              small
              shaped
              color="warning"
              >Edit</v-btn
            >
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="4" sm="2"> Subject </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="9">
            <v-text-field
              v-model="subject"
              :readonly="isView"
              :disabled="isView"
              @change="$v.subject.$touch()"
              @blur="$v.subject.$touch()"
              :error-messages="subjectErrors"
            />
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="4" sm="2"> Message </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="9">
            <div
              id="editor-container"
              :style="`color:${
                isView ? 'rgba(0, 0, 0, 0.38)' : 'black'
              } !important`"
            >
              <menu-command
                v-if="!isView"
                :editor="editor"
                :modal="modal"
                v-on:update:modal="modal = $event"
              />
              <editor-content
                style="
                  outline: auto;
                  padding: 10px;
                  max-height: 500px;
                  overflow: auto;
                "
                :editor="editor"
                v-model="editor.content"
                :class="`${isView ? 'Grey' : ''} ${
                  isMessageEmpty ? 'Empty' : ''
                }`"
              />
              <i
                v-if="!isView && !isMessageEmpty"
                style="color: orange; font-size: 12px"
                >* use (shift + enter) to go to next line</i
              >
              <div
                class="v-messages theme--light error--text mt-2"
                role="alert"
                v-if="isMessageEmpty && !isView"
              >
                <div class="v-messages__message">Message is required</div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row style="align-items: center">
          <v-col cols="4" sm="2"> Broadcast Date Time </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="5">
            <v-dialog
              ref="dateDialog"
              v-model="dateDialog"
              persistent
              :return-value.sync="date"
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @change="$v.date.$touch()"
                  @blur="$v.date.$touch()"
                  :error-messages="dateErrors"
                  :disabled="isView"
                />
              </template>
              <v-date-picker
                v-model="date"
                scrollable
                :min="todayDate"
                :readonly="isView"
                :disabled="isView"
              >
                <v-spacer />
                <v-btn text color="primary" @click="dateDialog = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dateDialog.save(date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="4">
            <v-menu
              ref="menu"
              v-model="menuTime"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="time"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="time"
                  label="Time"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @change="$v.time.$touch()"
                  @blur="$v.time.$touch()"
                  :error-messages="timeErrors"
                  :disabled="isView"
                />
              </template>
              <v-time-picker
                v-if="menuTime"
                v-model="time"
                full-width
                :min="todayDate == date ? timeNow : ''"
                @click:minute="$refs.menu.save(time)"
                :readonly="isView"
                :disabled="isView"
              />
            </v-menu>
          </v-col>
        </v-row>
        <div v-if="isView">
          <v-row style="align-items: center">
            <v-col cols="4" sm="2"> Created Date </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="9" style="color: rgba(0, 0, 0, 0.38)">
              {{ dataEdit ? dataEdit.data.created_at : '' }}
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="4" sm="2"> Created By </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="9" style="color: rgba(0, 0, 0, 0.38)">
              {{ dataEdit ? dataEdit.data.created_by : '' }}
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="ma-2 d-flex justify-end">
        <v-btn
          v-if="dataEdit != null"
          color="red"
          class="ma-1"
          style="color: white"
          @click="cancelEdit"
        >
          Back
        </v-btn>
        <v-btn
          v-else
          color="warning"
          class="ma-1"
          style="color: white"
          @click="() => $router.back()"
        >
          Back
        </v-btn>
        <v-btn
          v-if="!isView"
          color="success"
          class="ma-1"
          @click="openBroadcastConfirmModal(true)"
          :readonly="isView"
          :disabled="isView"
          >Save</v-btn
        >
      </div>
    </v-card>
    <v-dialog v-model="dialogConfirmation" width="500" persistent>
      <v-card>
        <v-card-title>
          Are you sure want to {{ isEdit ? 'edit' : 'send' }} broadcast ?
        </v-card-title>
        <v-card-text> Caution: this action cannot be undone ! </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn dark color="red" @click="() => (dialogConfirmation = false)">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="save"
            :disabled="loading"
            :loading="loading"
          >
            {{ isEdit ? 'Save' : 'Send' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMore" width="350">
      <v-card class="pa-2">
        <v-simple-table fixed-header height="300px">
          <template v-slot:default>
            <caption>
              email
            </caption>
            <thead>
              <tr>
                <th id="email" class="text-left">
                  <v-text-field label="Email" v-model="filterEmail" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in filteredEmail" :key="item.id">
                <td>{{ item.email }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2';
import Image from '@tiptap/extension-image';
import StarterKit from '@tiptap/starter-kit';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

import { isEmpty, date, showAlert } from '../../lib/helpers';

const ImageCustom = Image.configure({
  inline: true,
});
const dateObj = new Date();
const time = `${dateObj.getHours()}:${dateObj.getMinutes()}`;

export default {
  components: {
    EditorContent,
    ImageModal: () => import('../../components/editor/ImageModal.vue'),
    MenuCommand: () => import('../../components/editor/MenuCommand.vue'),
  },
  mixins: [validationMixin],
  validations: {
    subject: {
      required,
    },
    date: {
      required,
    },
    time: {
      required,
    },
  },
  data() {
    return {
      editor: new Editor({
        editable: true,
        extensions: [
          StarterKit,
          ImageCustom,
          // TextAlign.configure({
          //   types: ['heading', 'paragraph'],
          // }),
          // FontFamily,
          // TextStyle,
          // Highlight,
          // SmilieReplacer,
          // Typography,
        ],
        content: '',
      }),
      modal: false,
      subject: '',
      dateDialog: false,
      date: null,
      time: null,
      menuTime: false,
      isEdit: false,
      isView: false,
      dialogConfirmation: false,
      dialogMore: false,
      filterEmail: '',
      todayDate: date,
      timeNow: time,
      isSuccess: false,
      loadingView: false,
      id: null,
      isMessageEmpty: false,
      isLoadFailed: false,
    };
  },
  computed: {
    toAll: {
      set(data) {
        this.$store.commit('broadcast/broadcastEmail/setBroadcastAll', data);
      },
      get() {
        return this.$store.state.broadcast.broadcastEmail.broadcastAll;
      },
    },
    selected: {
      set(data) {
        this.$store.commit('broadcast/broadcastEmail/setSelectedData', data);
      },
      get() {
        return this.$store.state.broadcast.broadcastEmail.selectedData;
      },
    },
    dataEdit() {
      return this.$store.state.broadcast.broadcastEmail.dataEdit;
    },
    search() {
      return this.$store.state.broadcast.broadcastEmail.search;
    },
    sendTo() {
      if (this.toAll) {
        return 'All';
      }
      const email = this.selected.map((val) => val.email);
      if (email.length < 5) {
        return email.join(', ');
      }
      const spliced = email.slice(0, 4);
      return spliced.join(', ');
    },
    loading() {
      return this.$store.state.broadcast.broadcastEmail.loading;
    },
    filteredEmail() {
      if (this.toAll) {
        return [];
      }
      const filtered = this.selected.filter(
        (val) => val.email.indexOf(this.filterEmail) > -1
      );
      return filtered;
    },
    subjectErrors() {
      const errors = [];
      if (!this.$v.subject.$dirty) return errors;
      if (!this.$v.subject.required) errors.push('Subject is required');
      return errors;
    },
    dateErrors() {
      const errors = [];
      if (!this.$v.date.$dirty) return errors;
      if (!this.$v.date.required) errors.push('Date is required');
      return errors;
    },
    timeErrors() {
      const errors = [];
      if (!this.$v.time.$dirty) return errors;
      if (!this.$v.time.required) errors.push('time is required');
      return errors;
    },
  },
  mounted() {
    const selected = this.$store.state.broadcast.broadcastEmail.selectedData;
    const toAll = this.$store.state.broadcast.broadcastEmail.broadcastAll;
    switch (this.$route.params.action) {
      case 'add':
        if (!toAll && selected.length == 0) {
          this.$router.push('/broadcast/broadcast');
        }
        break;
      case 'view':
        this.isView = true;
        this.editor.setOptions({
          editable: false,
        });
        this.getDetail(this.$route.params.id);
        break;
      case 'edit':
        this.isEdit = true;
        if (this.dataEdit == null) {
          this.getDetail(this.$route.params.id);
        } else {
          this.setData(this.dataEdit);
        }
        break;
      default:
        this.$router.back();
    }
    this.editor.on('update', ({ editor }) => {
      this.checkContent(editor);
    });
    this.editor.on('blur', ({ editor }) => {
      this.checkContent(editor);
    });
  },
  methods: {
    checkContent(editor) {
      const content = editor
        .getHTML()
        .replace(/\s+/g, '')
        .replace(/<(?!img\b)[^>]*>|<\/?img[^>]*>/g, '');

      if (isEmpty(content)) {
        this.isMessageEmpty = true;
      } else {
        this.isMessageEmpty = false;
      }
    },
    addCommand(data) {
      if (data.data != null) {
        this.editor.chain().focus().setImage(data.data).run();
      }
    },
    save() {
      this.checkContent(this.editor);
      this.$v.$touch();
      if (!this.$v.$invalid && !this.isMessageEmpty) {
        const data = {
          date: this.date,
          time: this.time,
          subject: this.subject,
          message: this.editor.getHTML(),
          all: this.toAll,
          to:
            this.selected.length != 0 ? this.selected.map((val) => val.id) : [],
          search: this.search,
        };
        this.$store
          .dispatch('broadcast/broadcastEmail/saveBroadcast', {
            date,
            payload: data,
            isEdit: this.isEdit,
            id: this.id,
          })
          .then((response) => {
            if (response) {
              this.isSuccess = true;
              showAlert(
                this.$store,
                `${this.isEdit ? 'Edit' : 'Create'} broadcast email success !`,
                'mdi-check-circle',
                'green'
              );
              this.$store.commit('broadcast/broadcastEmail/clearDetail');
              this.$router.push('/broadcast/broadcast-history');
            } else {
              this.$vuetify.goTo(0);
            }
          })
          .finally(() => {
            this.openBroadcastConfirmModal(false);
          });
      } else {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Some field is required !', 'mdi-alert', 'red');
        this.dialogConfirmation = false;
      }
    },

    getDetail(id) {
      this.loadingView = true;
      this.$store
        .dispatch('broadcast/broadcastEmail/viewBroadcastDetail', {
          date,
          id,
        })
        .then((res) => {
          if (res) {
            this.setData(res);
          } else {
            this.isLoadFailed = true;
            showAlert(
              this.$store,
              'Failed to load data broadcast !',
              'mdi-alert',
              'red'
            );
            this.$router.push('/broadcast/broadcast-history');
          }
        })
        .finally(() => {
          this.loadingView = false;
        });
    },

    setData(res) {
      if (this.dataEdit == null) {
        this.selected = res.data.receiver;
        this.toAll = res.data.all;
      }

      this.id = this.$route.params.id;
      this.date = res.data.broadcast_date;
      this.time = res.data.broadcast_time;
      this.subject = res.data.subject;
      this.editor.commands.setContent(res.data.message);
      this.$store.commit('broadcast/broadcastEmail/setDataEdit', res);
    },

    syncronizeData() {
      const duplicate = JSON.parse(JSON.stringify(this.dataEdit));
      duplicate.data.id = this.id;
      duplicate.data.broadcast_date = this.date;
      duplicate.data.broadcast_time = this.time;
      duplicate.data.subject = this.subject;
      duplicate.data.message = this.editor.getHTML();
      this.$store.commit('broadcast/broadcastEmail/setDataEdit', duplicate);
    },

    cancelEdit() {
      this.clearData();
      this.$router.push('/broadcast/broadcast-history');
    },

    clearData() {
      this.$store.commit('broadcast/broadcastEmail/setDataEdit', null);
      this.$store.commit('broadcast/broadcastEmail/clearDetail');
    },

    openBroadcastConfirmModal(status) {
      this.dialogConfirmation = status;
    },

    seeMoreEmail() {
      this.dialogMore = true;
    },
  },
  beforeUnmount() {
    this.editor.destroy();
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  beforeRouteLeave(to, from, next) {
    if (this.isSuccess || this.isView || this.isLoadFailed) {
      this.clearData();
      next();
    } else if (to.path != '/broadcast/broadcast') {
      const answer = window.confirm(
        'Do you really want to leave? you have unsaved changes!'
      );
      if (answer) {
        this.clearData();
        next();
      } else {
        next(false);
      }
    } else {
      if (this.isEdit) this.syncronizeData();
      next();
    }
  },
};
</script>

<style>
.is-active {
  color: red;
}
.ProseMirror-focused {
  outline: none;
}
</style>

<style lang="scss">
.Empty {
  outline-color: red !important;
}

.Grey {
  img {
    max-width: 100%;
    height: auto;
    filter: opacity(0.3) !important;

    &.ProseMirror-selectednode {
      outline: 3px solid #68cef8;
    }
  }

  pre {
    background: grey !important;
    color: #fff !important;
  }
}

.ProseMirror {
  > * + * {
    margin-top: 0.75em;
  }

  img {
    max-width: 100%;
    height: auto;

    &.ProseMirror-selectednode {
      outline: 3px solid #68cef8;
    }
  }

  ul,
  ol {
    padding: 0 1rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.1;
  }

  mark {
    background-color: #faf594;
  }

  blockquote {
    padding-left: 1rem;
    border-left: 2px solid rgba(#0d0d0d, 0.2) !important;
  }

  hr {
    border: none;
    border-top: 2px solid rgba(#0d0d0d, 0.2) !important;
    margin: 2rem 0;
  }

  pre {
    background: #0d0d0d;
    color: #fff;
    font-family: 'JetBrainsMono', monospace;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;

    code {
      color: inherit;
      padding: 0;
      background: none;
      font-size: 0.8rem;
    }
  }
}
</style>
